import AppSalesReport from './appSalesReportResource';
import errorTransformer from '@/api/shared/transformers/errorTransformer';

function getAppSalesReportFile({ packageName, range }) {
  return AppSalesReport.get({
    ...range,
    dealers: packageName,
  }).catch(errorTransformer);
}

function sendAppSalesReportToEmail({ packageName, range, email }) {
  return AppSalesReport.get({
    ...range,
    dealers: packageName,
    send_to: email,
    is_async: true,
  }).catch(errorTransformer);
}

export default {
  getAppSalesReportFile,
  sendAppSalesReportToEmail,
};
